
const digest = '2b9d169c78fa8f4cfcb4bb694a4b2262285a34bbbf1c6ff28a5542a64250da6d';
const classes = {"wrapper":"_wrapper_kojsk_1","star":"_star_kojsk_11","icon":"_icon_kojsk_22"};
const css = `._wrapper_kojsk_1 {
  background: #e1ecfc;
  padding: 20px;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  width: 100%;
  flex-direction: row;
  gap: 15px;
}
._wrapper_kojsk_1 ._star_kojsk_11 {
  width: 44px;
  height: 44px;
  border-radius: 100%;
  background-color: #fff;
  position: relative;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
._wrapper_kojsk_1 ._star_kojsk_11 ._icon_kojsk_22 {
  height: 18px;
  width: 18px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  